import * as ngCore from '@angular/core'

import type * as models from '../models'
import { Store } from '../store'

import * as settings from './settings'

/** Renders table-level tools prepared by the scoped table store. */
@ngCore.Component({
  imports: [settings.Component],
  selector: 'atn-ds-table-toolbar',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Shared table state used by the template. */
  public readonly store = ngCore.inject(Store)

  /**
   * Stops table interactions and forwards the tool to the store.
   *
   * The originating event is preserved for tools such as clipboard paste
   * that position a dialog relative to the clicked toolbar button.
   */
  public toolClickHandler(event: Event, tool: models.Tool): void {
    event.stopPropagation()
    this.store.runTool(tool, event)
  }
}
